import { SnackbarProvider } from 'notistack';

export const withNotistack = (component: () => React.ReactNode) => () => (
  <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
    {component()}
  </SnackbarProvider>
);
